//dependencies
import dropdown from "angular-ui-bootstrap/src/dropdown";
import collapse from "angular-ui-bootstrap/src/collapse";
import tabs from "angular-ui-bootstrap/src/tabs";
import uiRouter from "angular-ui-router";

//modules

//services
// replace: \.(component|directive)\("(\w+)",\s*(\w+)\) with: $2,

//components
import tagNavigator from "servicestack/tags/navigator/tag-navigator";
import tagNavigatorDemo from "servicestack/tags/navigator/tag-navigator-demo";

//directives
// import parcelPicker from "servicestack/ipa-files/parcel-picker/parcel-picker.directive";

//states
import tagNavigatorStates, {
  getStates
} from "servicestack/tags/navigator/tag-navigator.states";

export const dependencies = [dropdown, collapse, tabs, uiRouter];

export const modules = {};

//const deps = ["emun.auth", "webutils", "webforms", "webmodals", "ui.router"];

export const services = {};

export const components = {
  tagNavigator,
  tagNavigatorDemo
};

export const directives = {};

export default {
  modules,
  services,
  dependencies,
  components,
  directives,
  states: {
    ...tagNavigatorStates,
    ...getStates(null, { name: "tag-navigator-demo" })
  }
};
